import React, { useReducer, createContext } from 'react';

const initialState = {
  customerDetails: {},
  customerDetailsFilled: {},
  currentStep: 1,
  homeLoanOptions: {},
  businessLoanOptions: {},
  assetDetails: {},
  assetDetailsFilled: {},
  businessDetails: {},
  businessDetailsFilled: {},
  applicantDetails: {},
  applicantDetailsFilled: {},
  fastLoanOptions: {},
  userAgrees: false,
  termsOpen: false,
  marketingConsent: false,
  referralSource: '',
};

export const FormContext = createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case 'resetAllFields':
      return {
        customerDetails: {},
        customerDetailsFilled: {},
        currentStep: 1,
        homeLoanOptions: {},
        businessLoanOptions: {},
        assetDetails: {},
        assetDetailsFilled: {},
        businessDetails: {},
        businessDetailsFilled: {},
        applicantDetails: {},
        applicantDetailsFilled: {},
        fastLoanOptions: {},
        userAgrees: false,
        termsOpen: false,
        marketingConsent: false,
        referralSource: '',
      };
    case 'updateCurrentStep':
      return {
        ...state,
        currentStep: action.payload,
      };
    case 'updateCustomerDetails':
      return {
        ...state,
        customerDetails: action.payload,
      };

    case 'updateCustomerDetailsFilled':
      return {
        ...state,
        customerDetailsFilled: action.payload,
      };
    case 'updateHomeLoanOptions':
      return {
        ...state,
        homeLoanOptions: action.payload,
      };
    case 'updateBusinessLoanOptions':
      return {
        ...state,
        businessLoanOptions: action.payload,
      };
    case 'updateAssetDetails':
      return {
        ...state,
        assetDetails: action.payload,
      };
    case 'updateAssetDetailsFilled':
      return {
        ...state,
        assetDetailsFilled: action.payload,
      };
    case 'updateBusinessDetails':
      return {
        ...state,
        businessDetails: action.payload,
      };
    case 'updateBusinessDetailsFilled':
      return {
        ...state,
        businessDetailsFilled: action.payload,
      };
    case 'updateApplicantDetails':
      return {
        ...state,
        applicantDetails: action.payload,
      };
    case 'updateApplicantDetailsFilled':
      return {
        ...state,
        applicantDetailsFilled: action.payload,
      };
    case 'updateFastLoanOptions':
      return {
        ...state,
        fastLoanOptions: action.payload,
      };
    case 'updateUserAgrees':
      return {
        ...state,
        userAgrees: action.payload,
      };
    case 'updateTermsOpen':
      return {
        ...state,
        termsOpen: action.payload,
      };
    case 'updateMarketingConsent':
      return {
        ...state,
        marketingConsent: action.payload,
      };
    case 'updateReferralSource':
      return {
        ...state,
        referralSource: action.payload,
      };
    default:
      throw new Error('Invalid action type');
  }
};

const StateProvider = ({ children }) => {
  const [formState, dispatch] = useReducer(reducer, initialState);
  return (
    <FormContext.Provider value={{ formState, dispatch }}>
      {children}
    </FormContext.Provider>
  );
};

const useFormContext = () => {
  const context = React.useContext(FormContext);
  if (context === undefined) {
    throw new Error(`useSiteContext must be used within a SiteProvider`);
  }
  return context;
};

export { StateProvider, useFormContext };
